module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/call_missed-b837a2f4bba1b856e8d70401418a527c.png";